import dayjs from 'dayjs'
import { defineStore } from 'pinia'

import { showToast } from 'vant'

export const useCommonStore = defineStore('common', {
  state: () => ({
    arrNotice: [],
    arrBanner: [],
    objLottery: {},
    objArea: {},
    objBonusOptimize: {},
    objBonusAverageOptimize: [],
  }),
  getters: {},
  actions: {
    setNotice(data) {
      this.arrNotice = data.map((item) => {
        return item.title
      })
    },
    setBanner(data) {
      this.arrBanner = data
    },
    setLottery(data) {
      this.objLottery = data
    },
    setArea(data) {
      this.objArea = data
    },
    setBonusOptimize(data) {
      this.objBonusOptimize = data
    },
    setBonuseAverageOptimize(data) {
      this.objBonusAverageOptimize = data
    },
    clearOptimize() {
      this.objBonusAverageOptimize = []
      this.objBonusOptimize = {}
    },
  },
})

export const useAccountStore = defineStore('account', {
  state: () => ({
    objInformation: {
      nickname: '',
    },
    objAccountBook: {},
    strApplication: '',
    objStoreBulletin: {},
    objTencentIm: {},
  }),
  getters: {},
  actions: {
    setTencentIm(data) {
      this.objTencentIm = data
    },
    setTencentUnreadCount(data) {
      this.objTencentIm.unReadCount = data
    },
    setInformation(data) {
      this.objInformation = data
    },
    setAccountBook(data) {
      this.objAccountBook = data
    },
    setApplication(data) {
      this.strApplication = data
    },
    setStoreBulletin(data) {
      this.objStoreBulletin = data
    },
    setAccountAvatar(data) {
      this.objInformation.avatar_url = data
    },
    setAccountNickname(data) {
      this.objInformation.nickname = data
    },
    setAccountSettlementMethod(data) {
      switch (data.pay_type) {
        case 1:
          this.objInformation.wechat_account_number = data.account_number
          this.objInformation.wechat_img_url = data.account_img
          this.objInformation.wechat_account_name = data.account_name
          break
        case 2:
          this.objInformation.alipay_account_number = data.account_number
          this.objInformation.alipay_img_url = data.account_img
          this.objInformation.alipay_account_name = data.account_name
          break
        case 3:
          this.objInformation.unipay_account_number = data.account_number
          this.objInformation.unipay_bank_name = data.unipay_bank_name
          this.objInformation.unipay_account_name = data.account_name
      }
    },
  },
})

export const useStoreStore = defineStore('store', {
  state: () => ({
    objInformation: {},
    objLotterySetting: {},
    arrLotterySetting: [
      {
        type: 'jcgyj',
        label: '冠亚军',
        state: false,
      },
      {
        type: 'jczq',
        label: '竞彩足球',
        state: false,
      },
      {
        type: 'bd',
        label: '北京单场',
        state: false,
      },
      {
        type: 'jclq',
        label: '竞彩篮球',
        state: false,
      },
      {
        type: 'ssq',
        label: '双色球',
        state: false,
      },
      {
        type: 'dlt',
        label: '大乐透',
        state: false,
      },
      {
        type: 'sd',
        label: '福彩3D',
        state: false,
      },
      {
        type: 'pls',
        label: '排列3',
        state: false,
      },
      {
        type: 'klb',
        label: '快乐8',
        state: false,
      },
      {
        type: 'plw',
        label: '排列5',
        state: false,
      },
      {
        type: 'sfc14',
        label: '足球14场',
        state: false,
      },
      {
        type: 'sfc9',
        label: '任选9场',
        state: false,
      },
      {
        type: 'qxc',
        label: '7星彩',
        state: false,
      },
      {
        type: 'qlc',
        label: '7乐彩',
        state: false,
      },
    ],
    arrShowLotterySetting: [],
    objWorkingTime: {
      0: { end: '23:00', start: '11:00' },
      1: { end: '22:00', start: '11:00' },
      2: { end: '22:00', start: '11:00' },
      3: { end: '22:00', start: '11:00' },
      4: { end: '22:00', start: '11:00' },
      5: { end: '22:00', start: '11:00' },
      6: { end: '23:00', start: '11:00' },
    },
    objGroupon: {
      type: '',
    },
    arrPaymentChannel: [],
  }),
  getters: {},
  actions: {
    setInformation(data) {
      this.objInformation = data
    },
    setLotterySetting(data) {
      let temp = {}
      data.forEach((item) => {
        if (item.type === 'sfc') {
          temp['sfc9'] = item
          temp['sfc14'] = item
        } else {
          temp[item.type] = item
        }

        this.arrLotterySetting.forEach((l) => {
          if (l.type.startsWith(item.type) && item.state === 1) {
            l.state = true
          }
        })
      })

      this.arrShowLotterySetting = this.arrLotterySetting.filter((item) => {
        return item.state === true
      })

      this.objLotterySetting = temp
    },
    setGroupon(data) {
      this.objGroupon = data
    },
    setPaymentChannel(data) {
      this.arrPaymentChannel = data
    },
  },
  persist: {
    omit: ['arrLotterySetting'],
  },
})

export const useSmsUpStore = defineStore('sms-up', {
  state: () => ({
    code: {},
  }),
  getters: {},
  actions: {
    setCode(data) {
      this.code = data
    },
  },
})

export const useGjMatchStore = defineStore('gj-match', {
  state: () => ({
    match: [],
    selected: [],
  }),
  getters: {},
  actions: {
    initMatch(data) {
      this.match = data
      this.match.forEach((item) => {
        item.selected = false
      })
    },
    changeItemState(data) {
      if (this.selected.length === 0) {
        this.match[data].selected = true
        this.selected.push(this.match[data])
      } else {
        if (this.selected[0].pk === this.match[data].pk) {
          this.match[data].selected = false
          this.selected = []
        } else {
          this.selected[0].selected = false
          this.match[data].selected = true
          this.selected[0] = this.match[data]
        }
      }
    },
    clearSelectedItem() {
      this.selected = []
      this.match.forEach((item) => {
        item.selected = false
      })
    },
  },
})

export const useGyjMatchStore = defineStore('gyj-match', {
  state: () => ({
    match: [],
    selected: [],
  }),
  getters: {},
  actions: {
    initMatch(data) {
      this.match = data
      this.match.forEach((item) => {
        item.selected = false
      })
    },
    changeItemState(data) {
      if (this.selected.length === 0) {
        this.match[data].selected = true
        this.selected.push(this.match[data])
      } else {
        if (this.selected[0].pk === this.match[data].pk) {
          this.match[data].selected = false
          this.selected = []
        } else {
          this.selected[0].selected = false
          this.match[data].selected = true
          this.selected[0] = this.match[data]
        }
      }
    },
    clearSelectedItem() {
      this.selected = []
      this.match.forEach((item) => {
        item.selected = false
      })
    },
  },
})

export const useJczqMatchStore = defineStore('jczq-match', {
  state: () => ({
    match: [],
    selected: [],
  }),
  getters: {},
  actions: {
    initMatch(data) {
      let results = {}
      data.forEach((item) => {
        let spfSelected = {
          0: false,
          1: false,
          3: false,
        }

        let rqspfSelected = {
          0: false,
          1: false,
          3: false,
        }

        let bfSelected = {
          10: false,
          11: false,
          12: false,
          13: false,
          14: false,
          15: false,
          20: false,
          21: false,
          22: false,
          23: false,
          24: false,
          25: false,
          30: false,
          31: false,
          32: false,
          33: false,
          40: false,
          41: false,
          42: false,
          50: false,
          51: false,
          52: false,
          90: false,
          99: false,
          '00': false,
          '01': false,
          '02': false,
          '03': false,
          '04': false,
          '05': false,
          '09': false,
        }

        let zjqSelected = {
          0: false,
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
        }

        let bqspfSelected = {
          '00': false,
          '01': false,
          '03': false,
          10: false,
          11: false,
          13: false,
          30: false,
          31: false,
          33: false,
        }

        item.obj_selected_label = {
          f_spf_f: {
            0: '负',
            1: '平',
            3: '胜',
          },
          f_rqspf_f: {
            0: '负',
            1: '平',
            3: '胜',
          },
          f_bf_f: {
            10: '1:0',
            11: '1:1',
            12: '1:2',
            13: '1:3',
            14: '1:4',
            15: '1:5',
            20: '2:0',
            21: '2:1',
            22: '2:2',
            23: '2:3',
            24: '2:4',
            25: '2:5',
            30: '3:0',
            31: '3:1',
            32: '3:2',
            33: '3:3',
            40: '4:0',
            41: '4:1',
            42: '4:2',
            50: '5:0',
            51: '5:1',
            52: '5:2',
            90: '胜其他',
            99: '平其他',
            '00': '0:0',
            '01': '0:1',
            '02': '0:2',
            '03': '0:3',
            '04': '0:4',
            '05': '0:5',
            '09': '负其他',
          },
          f_zjq_f: {
            0: '0',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7+',
          },
          f_bqspf_f: {
            '00': '负负',
            '01': '负平',
            '03': '负胜',
            10: '平负',
            11: '平平',
            13: '平胜',
            30: '胜负',
            31: '胜平',
            33: '胜胜',
          },
        }

        item.obj_selected_value = {
          f_rqspf_f: rqspfSelected,
          f_zjq_f: zjqSelected,
          f_bf_f: bfSelected,
          f_bqspf_f: bqspfSelected,
          f_spf_f: spfSelected,
        }

        let strEndTime = dayjs(item['end_time']).format('YYYY-MM-DD')
        let temp = results[strEndTime] || []
        temp.push(item)
        results[strEndTime] = temp
      })

      this.match = Object.keys(results)
        .sort((a, b) => dayjs(a).valueOf() - dayjs(b).valueOf())
        .map((key) => {
          return [key, results[key]]
        })
        .filter((item) => {
          return item[1].length > 0
        })
    },
    changeItemState(data) {
      this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item] =
        !this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item]
    },
    handleSelectedItem(data) {
      this.selected.push(data)
    },
    clearSelectedItem() {
      this.selected = []
    },
    removeSelectedItem(data) {
      let objSelected = this.selected[data]
      for (let i = 0; i < this.match.length; i++) {
        for (let j = 0; j < this.match[i][1].length; j++) {
          let objMatch = this.match[i][1][j]
          if (objMatch.number === objSelected.number) {
            let s = JSON.stringify(objMatch.obj_selected_value).replace(/true/g, 'false')
            this.match[i][1][j].obj_selected_value = JSON.parse(s)
          }
        }
      }
      this.selected.splice(data, 1)
    },
  },
})

export const useJclqMatchStore = defineStore('jclq-match', {
  state: () => ({
    match: [],
    selected: [],
  }),
  getters: {},
  actions: {
    initMatch(data) {
      let results = {}
      data.forEach((item) => {
        let rfsfSelected = {
          0: false,
          3: false,
        }

        let sfSelected = {
          0: false,
          3: false,
        }

        let dxfSelected = {
          0: false,
          1: false,
        }

        let sfcSelected = {
          '01': false,
          '02': false,
          '03': false,
          '04': false,
          '05': false,
          '06': false,
          '07': false,
          '08': false,
          '09': false,
          10: false,
          11: false,
          12: false,
        }

        item.obj_selected_label = {
          b_rfsf_f: {
            0: '客胜',
            3: '主胜',
          },
          b_sf_f: {
            0: '客胜',
            3: '主胜',
          },
          b_dxf_f: {
            0: '小分',
            1: '大分',
          },

          b_sfc_f: {
            '01': '1-5',
            '02': '6-10',
            '03': '11-15',
            '04': '16-20',
            '05': '21-25',
            '06': '26+',
            '07': '1-5',
            '08': '6-10',
            '09': '11-15',
            10: '16-20',
            11: '21-25',
            12: '26+',
          },
        }

        item.obj_selected_value = {
          b_rfsf_f: rfsfSelected,
          b_sf_f: sfSelected,
          b_dxf_f: dxfSelected,
          b_sfc_f: sfcSelected,
        }

        let strEndTime = dayjs(item['end_time']).format('YYYY-MM-DD')
        let temp = results[strEndTime] || []
        temp.push(item)
        results[strEndTime] = temp
      })

      this.match = Object.keys(results)
        .sort((a, b) => dayjs(a).valueOf() - dayjs(b).valueOf())
        .map((key) => {
          return [key, results[key]]
        })
        .filter((item) => {
          return item[1].length > 0
        })
    },
    changeItemState(data) {
      this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item] =
        !this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item]
    },
    handleSelectedItem(data) {
      this.selected.push(data)
    },
    clearSelectedItem() {
      this.selected = []
    },
    removeSelectedItem(data) {
      let objSelected = this.selected[data]
      for (let i = 0; i < this.match.length; i++) {
        for (let j = 0; j < this.match[i][1].length; j++) {
          let objMatch = this.match[i][1][j]
          if (objMatch.number === objSelected.number) {
            let s = JSON.stringify(objMatch.obj_selected_value).replace(/true/g, 'false')
            this.match[i][1][j].obj_selected_value = JSON.parse(s)
          }
        }
      }
      this.selected.splice(data, 1)
    },
  },
})

export const useBdMatchStore = defineStore('bd-match', {
  state: () => ({
    match: [],
    selected: [],
    currentPlayType: 'spf',
    currentSelected: [],
  }),
  getters: {},
  actions: {
    initMatch(data) {
      if (!data) {
        return
      }
      data.forEach((item) => {
        item[1] = item[1].filter((obj) => {
          return dayjs().isBefore(dayjs(obj.start_time))
        })

        item[1].forEach((val) => {
          let spfSelected = {
            0: false,
            1: false,
            3: false,
          }

          let bfSelected = {
            10: false,
            11: false,
            12: false,
            13: false,
            14: false,
            15: false,
            20: false,
            21: false,
            22: false,
            23: false,
            24: false,
            25: false,
            30: false,
            31: false,
            32: false,
            33: false,
            40: false,
            41: false,
            42: false,
            50: false,
            51: false,
            52: false,
            90: false,
            99: false,
            '00': false,
            '01': false,
            '02': false,
            '03': false,
            '04': false,
            '05': false,
            '09': false,
          }

          let zjqSelected = {
            0: false,
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false,
            7: false,
          }

          let bqspfSelected = {
            '00': false,
            '01': false,
            '03': false,
            10: false,
            11: false,
            13: false,
            30: false,
            31: false,
            33: false,
          }

          let sxdsSelected = {
            1: false,
            2: false,
            3: false,
            4: false,
          }

          val.obj_selected_value = {
            spf: spfSelected,
            zjq: zjqSelected,
            bf: bfSelected,
            bqcspf: bqspfSelected,
            sxds: sxdsSelected,
          }

          val.obj_selected_label = {
            spf: {
              0: '负',
              1: '平',
              3: '胜',
            },
            bf: {
              10: '1:0',
              11: '1:1',
              12: '1:2',
              13: '1:3',
              14: '1:4',
              15: '1:5',
              20: '2:0',
              21: '2:1',
              22: '2:2',
              23: '2:3',
              24: '2:4',
              25: '2:5',
              30: '3:0',
              31: '3:1',
              32: '3:2',
              33: '3:3',
              40: '4:0',
              41: '4:1',
              42: '4:2',
              50: '5:0',
              51: '5:1',
              52: '5:2',
              90: '胜其他',
              99: '平其他',
              '00': '0:0',
              '01': '0:1',
              '02': '0:2',
              '03': '0:3',
              '04': '0:4',
              '05': '0:5',
              '09': '负其他',
            },
            zjq: {
              0: '0',
              1: '1',
              2: '2',
              3: '3',
              4: '4',
              5: '5',
              6: '6',
              7: '7+',
            },
            bqcspf: {
              '00': '负负',
              '01': '负平',
              '03': '负胜',
              10: '平负',
              11: '平平',
              13: '平胜',
              30: '胜负',
              31: '胜平',
              33: '胜胜',
            },
            sxds: {
              1: '上单',
              2: '上双',
              3: '下单',
              4: '下双',
            },
          }

          val['id' + val.index] = false
        })
      })

      this.match = data
    },
    getSelectedCount(data) {
      let count = 0
      this.selected.forEach((item) => {
        if (JSON.stringify(item.obj_selected_value[data]).indexOf('true') > -1) {
          count += 1
        }
      })
      return count
    },
    changeItemState(data) {
      this.currentPlayType = data.play_type
      this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item] =
        !this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item]
    },
    handleSelectedItem(data) {
      this.selected.push(data)
      let tmp = []
      this.selected.forEach((item) => {
        if (JSON.stringify(item.obj_selected_value[this.currentPlayType]).indexOf('true') > -1) {
          tmp.push(item)
        }
      })
      this.currentSelected = tmp
    },
    clearSelectedItem(data) {
      this.selected.forEach((item) => {
        let keys = Object.keys(item.obj_selected_value[data])
        keys.forEach((val) => {
          item.obj_selected_value[data][val] = false
        })
        if (item[data + '_content']) {
          item[data + '_content'] = []
        }
      })
    },
    removeSelectedItem(data) {
      let temp = this.selected.find((item) => {
        return item.external_id === data.index
      })

      let keys = Object.keys(temp.obj_selected_value[data.type])
      keys.forEach((val) => {
        temp.obj_selected_value[data.type][val] = false
      })
      if (temp[data.type + '_content']) {
        temp[data.type + '_content'] = []
      }
    },
  },
})

export const useBdSfggMatchStore = defineStore('bd-sfgg-match', {
  state: () => ({
    match: [],
    selected: [],
    currentPlayType: 'sfgg',
    currentSelected: [],
  }),
  getters: {},
  actions: {
    initMatch(data) {
      if (!data) {
        return
      }
      data.forEach((item) => {
        item[1] = item[1].filter((obj) => {
          return dayjs().isBefore(dayjs(obj.start_time))
        })

        item[1].forEach((val) => {
          let sfggSelected = {
            0: false,
            3: false,
          }

          val.obj_selected_value = {
            sfgg: sfggSelected,
          }

          val.obj_selected_label = {
            sfgg: {
              0: '主负',
              3: '主胜',
            },
          }

          val['id' + val.index] = false
        })
      })

      this.match = data
    },
    getSelectedCount(data) {
      let count = 0
      this.selected.forEach((item) => {
        if (JSON.stringify(item.obj_selected_value[data]).indexOf('true') > -1) {
          count += 1
        }
      })
      return count
    },
    changeItemState(data) {
      this.currentPlayType = data.play_type
      this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item] =
        !this.match[data.date_key][1][data.match_key].obj_selected_value[data.play_type][data.item]
    },
    handleSelectedItem(data) {
      this.selected.push(data)
      let tmp = []
      this.selected.forEach((item) => {
        if (JSON.stringify(item.obj_selected_value[this.currentPlayType]).indexOf('true') > -1) {
          tmp.push(item)
        }
      })
      this.currentSelected = tmp
    },
    clearSelectedItem(data) {
      this.selected.forEach((item) => {
        let keys = Object.keys(item.obj_selected_value[data])
        keys.forEach((val) => {
          item.obj_selected_value[data][val] = false
        })
        if (item[data + '_content']) {
          item[data + '_content'] = []
        }
      })
    },
    removeSelectedItem(data) {
      let temp = this.selected.find((item) => {
        return item.external_id === data.index
      })

      let keys = Object.keys(temp.obj_selected_value[data.type])
      keys.forEach((val) => {
        temp.obj_selected_value[data.type][val] = false
      })
      if (temp[data.type + '_content']) {
        temp[data.type + '_content'] = []
      }
    },
  },
})

export const useSdIssueStore = defineStore('sd-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],
    type: '101',

    objNumber: {},
    objSelected: {
      1: [],
      2: [],
      3: [],
    },
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
      }

      let objNumber = {
        1: [],
        2: [],
        3: [],
      }
      Object.keys(objNumber).forEach((item) => {
        for (let i = 0; i <= 9; i++) {
          objNumber[item].push({
            number: i,
            isSelected: false,
          })
        }
      })

      this.objNumber = objNumber
    },
    initSelected() {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
      }
      this.selected = []
    },
    setType(data) {
      this.type = data
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      this.selected = data.bet_items.map((item) => {
        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: Number(item.bet_money) / 2,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let number = [[], [], []]
      if (this.type === '101') {
        number.forEach((item) => {
          item.push(parseInt(Math.random() * 10))
        })
      } else if (this.type === '201') {
        let temp = []
        while (temp.length < 3) {
          let n = parseInt(Math.random() * 10)
          if (!temp.includes(n)) {
            temp.push(n)
          }
        }
        number.forEach((item, i) => {
          item.push(temp[i])
        })
        number[2] = []
      } else if (this.type === '302') {
        while (number[0].length < 2) {
          let num = parseInt(Math.random() * 10)
          if (!number[0].includes(num)) {
            number[0].push(num)
          }
        }
        number[0] = number[0].sort()
      } else if (this.type === '601') {
        while (number[0].length < 3) {
          let num = parseInt(Math.random() * 10)
          if (!number[0].includes(num)) {
            number[0].push(num)
          }
        }
        number[0] = number[0].sort()
      }

      number.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1].forEach((v) => {
            if (v.number === val) {
              let data = {
                key: i + 1,
                item: v,
                type: this.type,
              }
              this.changeNumberState(data)
            }
          })
        })
      })
    },
    changeNumberState(data) {
      data.item.isSelected = !data.item.isSelected
      if (data.item.isSelected) {
        this.objSelected[data.key].push(data.item.number)
      } else {
        this.objSelected[data.key] = this.objSelected[data.key].filter((item) => {
          return item !== data.item.number
        })
      }
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupNumber(data) {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
      }
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      let arrSelected = this.selected[data].arrSelected
      this.objSelected = {
        1: arrSelected[0],
        2: arrSelected[1],
        3: arrSelected[2],
      }

      this.selected[data].arrSelected.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1][val].isSelected = true
        })
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const usePlsIssueStore = defineStore('pls-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],
    type: '201',

    objArea: {},
    objNumber: {},
    objSelected: {
      1: [],
      2: [],
      3: [],
    },
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
      }

      let objNumber = {
        1: [],
        2: [],
        3: [],
      }
      Object.keys(objNumber).forEach((item) => {
        for (let i = 0; i <= 9; i++) {
          objNumber[item].push({
            number: i,
            isSelected: false,
          })
        }
      })

      this.objNumber = objNumber
    },
    initSelected() {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
      }
      this.selected = []
    },
    setType(data) {
      this.type = data
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      this.selected = data.bet_items.map((item) => {
        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: Number(item.bet_money) / 2,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let number = [[], [], []]
      if (this.type === '201') {
        number.forEach((item) => {
          item.push(parseInt(Math.random() * 10))
        })
      } else if (this.type === '202') {
        let temp = []
        while (temp.length < 3) {
          let n = parseInt(Math.random() * 10)
          if (!temp.includes(n)) {
            temp.push(n)
          }
        }
        number.forEach((item, i) => {
          item.push(temp[i])
        })
        number[2] = []
      } else if (this.type === '203') {
        while (number[0].length < 2) {
          let num = parseInt(Math.random() * 10)
          if (!number[0].includes(num)) {
            number[0].push(num)
          }
        }
        number[0] = number[0].sort()
      } else if (this.type === '204') {
        while (number[0].length < 3) {
          let num = parseInt(Math.random() * 10)
          if (!number[0].includes(num)) {
            number[0].push(num)
          }
        }
        number[0] = number[0].sort()
      }

      number.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1].forEach((v) => {
            if (v.number === val) {
              let data = {
                key: i + 1,
                item: v,
                type: this.type,
              }
              this.changeNumberState(data)
            }
          })
        })
      })
    },
    changeNumberState(data) {
      data.item.isSelected = !data.item.isSelected
      if (data.item.isSelected) {
        this.objSelected[data.key].push(data.item.number)
      } else {
        this.objSelected[data.key] = this.objSelected[data.key].filter((item) => {
          return item !== data.item.number
        })
      }
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupNumber(data) {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
      }
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      let arrSelected = this.selected[data].arrSelected
      this.objSelected = {
        1: arrSelected[0],
        2: arrSelected[1],
        3: arrSelected[2],
      }

      this.selected[data].arrSelected.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1][val].isSelected = true
        })
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const usePlwIssueStore = defineStore('plw-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],

    objNumber: {},
    objSelected: {},
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      }

      let objNumber = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      }
      Object.keys(objNumber).forEach((item) => {
        for (let i = 0; i <= 9; i++) {
          objNumber[item].push({
            number: i,
            isSelected: false,
          })
        }
      })

      this.objNumber = objNumber
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      this.selected = data.bet_items.map((item) => {
        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: Number(item.bet_money) / 2,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let number = [[], [], [], [], []]
      for (const i in number) {
        number[i].push(parseInt(Math.random() * 9))
      }

      number.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1].forEach((v) => {
            if (v.number === val) {
              let data = {
                key: i + 1,
                item: v,
                type: this.type,
              }
              this.changeNumberState(data)
            }
          })
        })
      })
    },
    changeNumberState(data) {
      data.item.isSelected = !data.item.isSelected
      if (data.item.isSelected) {
        this.objSelected[data.key].push(data.item.number)
      } else {
        this.objSelected[data.key] = this.objSelected[data.key].filter((item) => {
          return item !== data.item.number
        })
      }
    },
    addOneGroupRandomNumber() {
      let number = [[], [], [], [], []]
      for (const i in number) {
        number[i].push(parseInt(Math.random() * 9))
      }

      number.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1].forEach((v) => {
            if (v.number === val) {
              let data = {
                key: i + 1,
                item: v,
                type: this.type,
              }
              this.changeNumberState(data)
            }
          })
        })
      })

      let betCodes = number.map((item) => {
        return item.sort().join('|')
      })

      let data = {
        betCodes: betCodes.join(','),
        betCount: 1,
        betMoney: 2,
        strPlayType: '101',
        arrSelected: number,
      }
      this.objSelected = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      }
      this.selected.push(data)
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupNumber(data) {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      }
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      let arrSelected = this.selected[data].arrSelected
      this.objSelected = {
        1: arrSelected[0],
        2: arrSelected[1],
        3: arrSelected[2],
        4: arrSelected[3],
        5: arrSelected[4],
      }

      this.selected[data].arrSelected.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1][val].isSelected = true
        })
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const useSsqIssueStore = defineStore('ssq-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],

    arrRedDan: [],
    arrRedTuo: [],
    arrBlueTuo: [],

    arrRedDanSelected: [],
    arrRedTuoSelected: [],
    arrBlueTuoSelected: [],
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.arrBlueTuoSelected = []

      let arrRedTuo = []
      let arrRedDan = []
      let arrBlueTuo = []

      for (let i = 1; i <= 33; i++) {
        i < 10 && (i = '0' + i)
        arrRedTuo.push({ number: String(i), isSelected: false })
        arrRedDan.push({ number: String(i), isSelected: false })
      }
      for (let i = 1; i <= 16; i++) {
        i < 10 && (i = '0' + i)
        arrBlueTuo.push({ number: String(i), isSelected: false })
      }

      this.arrRedTuo = arrRedTuo
      this.arrRedDan = arrRedDan
      this.arrBlueTuo = arrBlueTuo
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      this.selected = data.bet_items.map((item) => {
        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: Number(item.bet_money) / 2,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let redNumber = []
      let blueNumber = []

      while (redNumber.length < 6) {
        let temp = parseInt(Math.random() * 33) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(String(temp))) {
          redNumber.push(String(temp))
        }
      }

      while (blueNumber.length < 1) {
        let temp = parseInt(Math.random() * 16) + 1
        temp < 10 && (temp = '0' + temp)
        if (!blueNumber.includes(String(temp))) {
          blueNumber.push(String(temp))
        }
      }

      let redBall = redNumber.sort().map((item) => {
        let t = this.arrRedTuo.filter((val) => {
          return val.number === item
        })[0]
        return t
      })

      let blueBall = blueNumber.sort().map((item) => {
        let t = this.arrBlueTuo.filter((val) => {
          return val.number === item
        })[0]
        return t
      })

      redBall.forEach((item, key) => {
        this.changeRedTuoState({
          item: item,
          key: key,
        })
      })

      blueBall.forEach((item, key) => {
        this.changeBlueTuoState({
          item: item,
          key: key,
        })
      })
    },
    changeRedTuoState(data) {
      if (this.arrRedDan[data.key].isSelected) {
        this.arrRedDan[data.key].isSelected = false
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      } else {
        data.item.isSelected = !data.item.isSelected
        if (data.item.isSelected) {
          this.arrRedTuoSelected.push(data.item.number)
        } else {
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
        }
      }
    },
    changeRedDanState(data) {
      if (data.item.isSelected) {
        if (this.arrRedDanSelected.length < 5) {
          this.arrRedDanSelected.push(data.item.number)
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
          this.arrRedTuo[data.key].isSelected = false
        } else {
          data.item.isSelected = false
          showToast('红球胆码最多选5个！')
        }
      } else {
        this.arrRedTuo[data.key].isSelected = true
        this.arrRedTuoSelected.push(data.item.number)
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      }
    },
    changeBlueTuoState(data) {
      data.item.isSelected = !data.item.isSelected
      if (data.item.isSelected) {
        this.arrBlueTuoSelected.push(data.item.number)
      } else {
        this.arrBlueTuoSelected = this.arrBlueTuoSelected.filter((item) => {
          return item !== data.item.number
        })
      }
    },
    addOneGroupNumber(data) {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.arrBlueTuoSelected = []
      this.selected.push(data)
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupRandomNumber() {
      let redNumber = []
      let blueNumber = []

      while (redNumber.length < 6) {
        let temp = parseInt(Math.random() * 33) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(String(temp))) {
          redNumber.push(String(temp))
        }
      }

      while (blueNumber.length < 1) {
        let temp = parseInt(Math.random() * 16) + 1
        temp < 10 && (temp = '0' + temp)
        if (!blueNumber.includes(String(temp))) {
          blueNumber.push(String(temp))
        }
      }

      let redBall = redNumber.sort()
      let blueBall = blueNumber.sort()

      let betCodes = redBall.join(',') + '#' + blueBall.join(',')

      let arrSelected = []
      redBall.forEach((item) => {
        arrSelected.push({
          type: 'rt',
          number: item,
        })
      })

      blueBall.forEach((item) => {
        arrSelected.push({
          type: 'bt',
          number: item,
        })
      })

      let data = {
        betCodes: betCodes,
        betCount: 1,
        betMoney: 2,
        strPlayType: '101',
        arrSelected: arrSelected,
      }
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.arrBlueTuoSelected = []
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      this.selected[data].arrSelected.forEach((o) => {
        if (o.type === 'rd') {
          this.arrRedDanSelected.push(o.number)

          let obj = this.arrRedDan.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        } else if (o.type === 'rt') {
          this.arrRedTuoSelected.push(o.number)

          let obj = this.arrRedTuo.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        } else if (o.type === 'bt') {
          this.arrBlueTuoSelected.push(o.number)

          let obj = this.arrBlueTuo.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        }
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const useDltIssueStore = defineStore('dlt-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],

    arrRedDan: [],
    arrRedTuo: [],
    arrBlueDan: [],
    arrBlueTuo: [],

    arrRedDanSelected: [],
    arrRedTuoSelected: [],
    arrBlueDanSelected: [],
    arrBlueTuoSelected: [],
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.arrBlueDanSelected = []
      this.arrBlueTuoSelected = []

      let arrRedTuo = []
      let arrRedDan = []
      let arrBlueTuo = []
      let arrBlueDan = []

      for (let i = 1; i <= 35; i++) {
        i < 10 && (i = '0' + i)
        arrRedTuo.push({ number: String(i), isSelected: false })
        arrRedDan.push({ number: String(i), isSelected: false })
      }
      for (let i = 1; i <= 12; i++) {
        i < 10 && (i = '0' + i)
        arrBlueTuo.push({ number: String(i), isSelected: false })
        arrBlueDan.push({ number: String(i), isSelected: false })
      }

      this.arrRedTuo = arrRedTuo
      this.arrRedDan = arrRedDan
      this.arrBlueTuo = arrBlueTuo
      this.arrBlueDan = arrBlueDan
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      let arrPlayType = ['103', '104', '107']
      this.selected = data.bet_items.map((item) => {
        let betCount = arrPlayType.includes(item.play_type)
          ? Number(item.bet_money) / 3
          : Number(item.bet_money) / 2

        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: betCount,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let redNumber = []
      let blueNumber = []

      while (redNumber.length < 5) {
        let temp = parseInt(Math.random() * 35) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(String(temp))) {
          redNumber.push(String(temp))
        }
      }

      while (blueNumber.length < 2) {
        let temp = parseInt(Math.random() * 12) + 1
        temp < 10 && (temp = '0' + temp)
        if (!blueNumber.includes(String(temp))) {
          blueNumber.push(String(temp))
        }
      }

      let redBall = redNumber.sort().map((item) => {
        let t = this.arrRedTuo.filter((val) => {
          return val.number === item
        })[0]
        return t
      })

      let blueBall = blueNumber.sort().map((item) => {
        let t = this.arrBlueTuo.filter((val) => {
          return val.number === item
        })[0]
        return t
      })

      redBall.forEach((item, key) => {
        this.changeRedTuoState({
          item: item,
          key: key,
        })
      })

      blueBall.forEach((item, key) => {
        this.changeBlueTuoState({
          item: item,
          key: key,
        })
      })
    },
    changeRedTuoState(data) {
      if (this.arrRedDan[data.key].isSelected) {
        this.arrRedDan[data.key].isSelected = false
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      } else {
        data.item.isSelected = !data.item.isSelected
        if (data.item.isSelected) {
          this.arrRedTuoSelected.push(data.item.number)
        } else {
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
        }
      }
    },
    changeRedDanState(data) {
      if (data.item.isSelected) {
        if (this.arrRedDanSelected.length < 4) {
          this.arrRedDanSelected.push(data.item.number)
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
          this.arrRedTuo[data.key].isSelected = false
        } else {
          data.item.isSelected = false
          showToast('红球胆码最多选4个！')
        }
      } else {
        this.arrRedTuo[data.key].isSelected = true
        this.arrRedTuoSelected.push(data.item.number)
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      }
    },
    changeBlueTuoState(data) {
      if (this.arrBlueDan[data.key].isSelected) {
        this.arrBlueDan[data.key].isSelected = false
        this.arrBlueDanSelected = this.arrBlueDanSelected.filter((item) => {
          return item !== data.item.number
        })
      } else {
        data.item.isSelected = !data.item.isSelected
        if (data.item.isSelected) {
          this.arrBlueTuoSelected.push(data.item.number)
        } else {
          this.arrBlueTuoSelected = this.arrBlueTuoSelected.filter((item) => {
            return item !== data.item.number
          })
        }
      }
    },
    changeBlueDanState(data) {
      if (data.item.isSelected) {
        if (this.arrBlueDanSelected.length < 1) {
          this.arrBlueDanSelected.push(data.item.number)
          this.arrBlueTuoSelected = this.arrBlueTuoSelected.filter((item) => {
            return item !== data.item.number
          })
          this.arrBlueTuo[data.key].isSelected = false
        } else {
          data.item.isSelected = false
          showToast('蓝球胆码最多选1个！')
        }
      } else {
        this.arrBlueTuo[data.key].isSelected = true
        this.arrBlueTuoSelected.push(data.item.number)
        this.arrBlueDanSelected = this.arrBlueDanSelected.filter((item) => {
          return item !== data.item.number
        })
      }
    },
    addOneGroupNumber(data) {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.arrBlueDanSelected = []
      this.arrBlueTuoSelected = []
      this.selected.push(data)
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupRandomNumber() {
      let redNumber = []
      let blueNumber = []

      while (redNumber.length < 5) {
        let temp = parseInt(Math.random() * 35) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(String(temp))) {
          redNumber.push(String(temp))
        }
      }

      while (blueNumber.length < 2) {
        let temp = parseInt(Math.random() * 12) + 1
        temp < 10 && (temp = '0' + temp)
        if (!blueNumber.includes(String(temp))) {
          blueNumber.push(String(temp))
        }
      }

      let redBall = redNumber.sort()
      let blueBall = blueNumber.sort()

      let betCodes = redBall.join(',') + '#' + blueBall.join(',')

      let arrSelected = []
      redBall.forEach((item) => {
        arrSelected.push({
          type: 'rt',
          number: item,
        })
      })

      blueBall.forEach((item) => {
        arrSelected.push({
          type: 'bt',
          number: item,
        })
      })

      let data = {
        betCodes: betCodes,
        betCount: 1,
        betMoney: 2,
        strPlayType: '101',
        arrSelected: arrSelected,
      }
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.arrBlueDanSelected = []
      this.arrBlueTuoSelected = []
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      this.selected[data].arrSelected.forEach((o) => {
        if (o.type === 'rd') {
          this.arrRedDanSelected.push(o.number)

          let obj = this.arrRedDan.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        } else if (o.type === 'rt') {
          this.arrRedTuoSelected.push(o.number)

          let obj = this.arrRedTuo.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        } else if (o.type === 'bd') {
          this.arrBlueDanSelected.push(o.number)

          let obj = this.arrBlueDan.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        } else if (o.type === 'bt') {
          this.arrBlueTuoSelected.push(o.number)

          let obj = this.arrBlueTuo.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        }
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const useQlcIssueStore = defineStore('qlc-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],

    arrRedDan: [],
    arrRedTuo: [],

    arrRedDanSelected: [],
    arrRedTuoSelected: [],
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []

      let arrRedTuo = []
      let arrRedDan = []

      for (let i = 1; i <= 30; i++) {
        i < 10 && (i = '0' + i)
        arrRedTuo.push({ number: i, isSelected: false })
        arrRedDan.push({ number: i, isSelected: false })
      }

      this.arrRedTuo = arrRedTuo
      this.arrRedDan = arrRedDan
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      this.selected = data.bet_items.map((item) => {
        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: Number(item.bet_money) / 2,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let redNumber = []

      while (redNumber.length < 7) {
        let temp = parseInt(Math.random() * 30) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(temp)) {
          redNumber.push(temp)
        }
      }

      let redBall = redNumber.sort().map((item) => {
        let t = this.arrRedTuo.filter((val) => {
          return val.number === item
        })[0]
        return t
      })

      redBall.forEach((item, key) => {
        this.changeRedTuoState({
          item: item,
          key: key,
        })
      })
    },
    changeRedTuoState(data) {
      if (this.arrRedDan[data.key].isSelected) {
        this.arrRedDan[data.key].isSelected = false
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      } else {
        data.item.isSelected = !data.item.isSelected
        if (data.item.isSelected) {
          this.arrRedTuoSelected.push(data.item.number)
        } else {
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
        }
      }
    },
    changeRedDanState(data) {
      if (data.item.isSelected) {
        if (this.arrRedDanSelected.length < 6) {
          this.arrRedDanSelected.push(data.item.number)
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
          this.arrRedTuo[data.key].isSelected = false
        } else {
          data.item.isSelected = false
          showToast('红球胆码最多选6个！')
        }
      } else {
        this.arrRedTuo[data.key].isSelected = true
        this.arrRedTuoSelected.push(data.item.number)
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      }
    },
    addOneGroupNumber(data) {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.selected.push(data)
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupRandomNumber() {
      let redNumber = []

      while (redNumber.length < 7) {
        let temp = parseInt(Math.random() * 30) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(temp)) {
          redNumber.push(temp)
        }
      }

      let redBall = redNumber.sort()

      let betCodes = redBall.join(',')

      let arrSelected = []
      redBall.forEach((item) => {
        arrSelected.push({
          type: 'rt',
          number: item,
        })
      })

      let data = {
        betCodes: betCodes,
        betCount: 1,
        betMoney: 2,
        strPlayType: '101',
        arrSelected: arrSelected,
      }
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      this.selected[data].arrSelected.forEach((o) => {
        if (o.type === 'rd') {
          this.arrRedDanSelected.push(o.number)

          let obj = this.arrRedDan.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        } else if (o.type === 'rt') {
          this.arrRedTuoSelected.push(o.number)

          let obj = this.arrRedTuo.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        }
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const useKlbIssueStore = defineStore('klb-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],
    type: '5',

    arrRedDan: [],
    arrRedTuo: [],

    arrRedDanSelected: [],
    arrRedTuoSelected: [],
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []

      let arrRedTuo = []
      let arrRedDan = []

      for (let i = 1; i <= 80; i++) {
        i < 10 && (i = '0' + i)
        arrRedTuo.push({ number: String(i), isSelected: false })
        arrRedDan.push({ number: String(i), isSelected: false })
      }

      this.arrRedTuo = arrRedTuo
      this.arrRedDan = arrRedDan
    },
    setType(data) {
      this.type = data
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      this.selected = data.bet_items.map((item) => {
        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: Number(item.bet_money) / 2,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let redNumber = []

      while (redNumber.length < Number(this.type)) {
        let temp = parseInt(Math.random() * 80) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(String(temp))) {
          redNumber.push(String(temp))
        }
      }

      let redBall = redNumber.sort().map((item) => {
        let t = this.arrRedTuo.filter((val) => {
          return val.number === item
        })[0]
        return t
      })

      redBall.forEach((item, key) => {
        this.changeRedTuoState({
          item: item,
          key: key,
        })
      })
    },
    changeRedTuoState(data) {
      if (this.arrRedDan[data.key].isSelected) {
        this.arrRedDan[data.key].isSelected = false
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      } else {
        data.item.isSelected = !data.item.isSelected
        if (data.item.isSelected) {
          this.arrRedTuoSelected.push(data.item.number)
        } else {
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
        }
      }
    },
    changeRedDanState(data) {
      if (data.item.isSelected) {
        if (this.arrRedDanSelected.length < Number(this.type) - 1) {
          this.arrRedDanSelected.push(data.item.number)
          this.arrRedTuoSelected = this.arrRedTuoSelected.filter((item) => {
            return item !== data.item.number
          })
          this.arrRedTuo[data.key].isSelected = false
        } else {
          data.item.isSelected = false
          showToast(`胆码最多选${Number(this.type) - 1}个！`)
        }
      } else {
        this.arrRedTuo[data.key].isSelected = true
        this.arrRedTuoSelected.push(data.item.number)
        this.arrRedDanSelected = this.arrRedDanSelected.filter((item) => {
          return item !== data.item.number
        })
      }
    },
    addOneGroupNumber(data) {
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.selected.push(data)
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupRandomNumber() {
      let redNumber = []

      while (redNumber.length < Number(this.type)) {
        let temp = parseInt(Math.random() * 30) + 1
        temp < 10 && (temp = '0' + temp)
        if (!redNumber.includes(String(temp))) {
          redNumber.push(String(temp))
        }
      }

      let redBall = redNumber.sort()

      let betCodes = redBall.join(',')

      let arrSelected = []
      redBall.forEach((item) => {
        arrSelected.push({
          type: 'rt',
          number: item,
        })
      })

      let strPlayType = this.type.length === 1 ? `0${this.type}` : this.type

      let data = {
        betCodes: betCodes,
        betCount: 1,
        betMoney: 2,
        strPlayType: `1${strPlayType}1`,
        arrSelected: arrSelected,
      }
      this.arrRedDanSelected = []
      this.arrRedTuoSelected = []
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      this.selected[data].arrSelected.forEach((o) => {
        if (o.type === 'rd') {
          this.arrRedDanSelected.push(o.number)

          let obj = this.arrRedDan.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        } else if (o.type === 'rt') {
          this.arrRedTuoSelected.push(o.number)

          let obj = this.arrRedTuo.find((v) => {
            return Number(v.number) === Number(o.number)
          })
          obj.isSelected = true
        }
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const useQxcIssueStore = defineStore('qxc-issue', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    updateIndex: '',
    selected: [],

    objNumber: {},
    objSelected: {},
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initNumber() {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
      }

      let objNumber = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
      }
      Object.keys(objNumber).forEach((item) => {
        let j = item === '7' ? 14 : 9
        for (let i = 0; i <= j; i++) {
          objNumber[item].push({
            number: i,
            isSelected: false,
          })
        }
      })

      this.objNumber = objNumber
    },
    setUpdateIndex(data) {
      this.updateIndex = String(data)
    },
    setRepeat(data) {
      this.selected = data.bet_items.map((item) => {
        return {
          arrSelected: item.selected,
          betCodes: item.bet_codes,
          betCount: Number(item.bet_money) / 2,
          betMoney: item.bet_money,
          strPlayType: item.play_type,
        }
      })
    },
    randomNumber() {
      let number = [[], [], [], [], [], [], []]
      for (const i in number) {
        if (i < 6) {
          number[i].push(parseInt(Math.random() * 9))
        } else {
          number[i].push(parseInt(Math.random() * 14))
        }
      }

      number.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1].forEach((v) => {
            if (v.number === val) {
              let data = {
                key: i + 1,
                item: v,
              }
              this.changeNumberState(data)
            }
          })
        })
      })
    },
    changeNumberState(data) {
      data.item.isSelected = !data.item.isSelected
      if (data.item.isSelected) {
        this.objSelected[data.key].push(data.item.number)
      } else {
        this.objSelected[data.key] = this.objSelected[data.key].filter((item) => {
          return item !== data.item.number
        })
      }
    },
    addOneGroupRandomNumber() {
      let number = [[], [], [], [], [], [], []]
      for (const i in number) {
        if (i < 6) {
          number[i].push(parseInt(Math.random() * 9))
        } else {
          number[i].push(parseInt(Math.random() * 14))
        }
      }

      number.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1].forEach((v) => {
            if (v.number === val) {
              let data = {
                key: i + 1,
                item: v,
              }
              this.changeNumberState(data)
            }
          })
        })
      })

      let betCodes = number.map((item) => {
        return item.sort().join('|')
      })

      let data = {
        betCodes: betCodes.join(','),
        betCount: 1,
        betMoney: 2,
        strPlayType: '101',
        arrSelected: number,
      }
      this.objSelected = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
      }
      this.selected.push(data)
    },
    delOneGroupNumber(data) {
      this.selected.splice(data, 1)
    },
    addOneGroupNumber(data) {
      this.objSelected = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
      }
      this.selected.push(data)
    },
    updateOneGroupNumber(data) {
      this.selected[data.index] = data.data
    },
    restoreOneGroupNumber(data) {
      let arrSelected = this.selected[data].arrSelected
      this.objSelected = {
        1: arrSelected[0],
        2: arrSelected[1],
        3: arrSelected[2],
        4: arrSelected[3],
        5: arrSelected[4],
        6: arrSelected[5],
        7: arrSelected[6],
      }

      this.selected[data].arrSelected.forEach((item, i) => {
        item.forEach((val) => {
          this.objNumber[i + 1][val].isSelected = true
        })
      })
    },
    clearAllGroupNumber() {
      this.selected = []
    },
  },
})

export const useSfc14MatchStore = defineStore('sfc14-match', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    match: [],
    selected: [],
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initMatch(data) {
      let results = []
      data.forEach((item) => {
        item.obj_selected_label = {
          0: '负',
          1: '平',
          3: '胜',
        }

        item.obj_selected_value = {
          0: false,
          1: false,
          3: false,
        }

        results.push(item)
      })

      this.match = results
      this.selected = []
    },
    initSelected() {
      this.match.forEach((item) => {
        item.obj_selected_label = {
          0: '负',
          1: '平',
          3: '胜',
        }
        item.obj_selected_value = {
          0: false,
          1: false,
          3: false,
        }
      })
      this.selected = []
    },
    changeItemState(data) {
      data.item.obj_selected_value[data.option] = !data.item.obj_selected_value[data.option]
    },
    randomNumber() {
      let number = []
      while (number.length < 14) {
        let num = parseInt(Math.random() * 14)
        if (!number.includes(num)) {
          number.push(num)
        }
      }

      let option = ['0', '1', '3']

      number.forEach((item) => {
        this.changeItemState({
          item: this.match[item],
          option: option[parseInt(Math.random() * 3)],
        })

        let selected = Object.values(this.match[item].obj_selected_value)
        if (JSON.stringify(selected).indexOf('true') > -1) {
          this.handleSelectedItem(this.match[item])
        }
      })
    },
    handleSelectedItem(data) {
      this.selected.push(data)
    },
    clearSelectedItem() {
      this.selected = []
    },
    removeSelectedItem(data) {
      let objSelected = this.selected[data.index]
      for (let i = 0; i < this.match.length; i++) {
        for (let j = 0; j < this.match.length; j++) {
          let objMatch = this.match[j]
          if (objMatch.index === objSelected.index) {
            let s = JSON.stringify(objMatch.obj_selected_value).replace(/true/g, 'false')
            this.match[j].obj_selected_value = JSON.parse(s)
          }
        }
      }
      this.selected.splice(data.index, 1)
    },
  },
})

export const useSfc9MatchStore = defineStore('sfc9-match', {
  state: () => ({
    issue: {
      number: '',
      end_time: '',
    },
    match: [],
    selected: [],
  }),
  getters: {},
  actions: {
    initIssue(data) {
      this.issue = data
    },
    initMatch(data) {
      let results = []
      data.forEach((item) => {
        item.obj_selected_label = {
          0: '负',
          1: '平',
          3: '胜',
        }

        item.obj_selected_value = {
          0: false,
          1: false,
          3: false,
        }

        results.push(item)
      })

      this.match = results
      this.selected = []
    },
    initSelected() {
      this.match.forEach((item) => {
        item.obj_selected_label = {
          0: '负',
          1: '平',
          3: '胜',
        }
        item.obj_selected_value = {
          0: false,
          1: false,
          3: false,
        }
      })
      this.selected = []
    },
    changeItemState(data) {
      data.item.obj_selected_value[data.option] = !data.item.obj_selected_value[data.option]
    },
    randomNumber() {
      let number = []
      while (number.length < 9) {
        let num = parseInt(Math.random() * 9)
        if (!number.includes(num)) {
          number.push(num)
        }
      }

      let option = ['0', '1', '3']

      number.forEach((item) => {
        this.changeItemState({
          item: this.match[item],
          option: option[parseInt(Math.random() * 3)],
        })

        let selected = Object.values(this.match[item].obj_selected_value)
        if (JSON.stringify(selected).indexOf('true') > -1) {
          this.handleSelectedItem(this.match[item])
        }
      })
    },
    handleSelectedItem(data) {
      this.selected.push(data)
    },
    clearSelectedItem() {
      this.selected = []
    },
    removeSelectedItem(data) {
      let objSelected = this.selected[data.index]
      for (let i = 0; i < this.match.length; i++) {
        for (let j = 0; j < this.match.length; j++) {
          let objMatch = this.match[j]
          if (objMatch.index === objSelected.index) {
            let s = JSON.stringify(objMatch.obj_selected_value).replace(/true/g, 'false')
            this.match[j].obj_selected_value = JSON.parse(s)
          }
        }
      }
      this.selected.splice(data.index, 1)
    },
  },
})
